import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Tool from "src/pages/me/tool";
import Lesson from "src/pages/me/lesson";
import Size from "src/pages/me/size";
import MyHazards from "src/pages/me/myHazards";
// «Урьдчилсан шалгалт» — АШУА-гийн бүртгэсэн ажил дээрх 5А / 15А.
// Өмнө нь ажилтан өөрт нь ямар шалгалт хүлээгдэж байгааг ХААНААС Ч
// харах боломжгүй байсан (/highrisk/prework5a|15 рүү хөтлөх холбоосгүй).
import MyPrework from "src/pages/me/myPrework";
// «ХАБЭА санал гомдол» — ХЭМАБМТ-08 4.1.3-ын эрхийн оролт.
// ⚠ ЦЭСЭЭР нээгээгүй, /me дотор тавьсан нь ЗОРИУД: цэс нь SSO-гийн эрхээр
//   хумигддаг тул ажилтны ихэнхэд ХАБЭА-гийн цэс харагддаггүй. Санал
//   бичих оролт эрхийн цаана үлдвэл журмын эрх хэрэгжихгүй.
import MyFeedback from "src/pages/me/myFeedback";
// /me → «Журмаас асуух» таб (2026-10-29, хэрэглэгч: «вэб дээр журмаас
// асуух хэсгийг /me дотор хий»).
//
// ⚠ ЦЭСЭЭР нээгдээгүй /knowledge/ask-ийг ЭНД тавих нь ЗОРИУД — «Санал
//   гомдол»-той ижил шалтгаан: цэс нь SSO-гийн эрхээр хумигддаг тул
//   ажилтны ихэнхэд ХАБЭА-гийн цэс харагддаггүй. Журмаас асуух боломж
//   эрхийн цаана үлдвэл ажилтан заалтаа хэзээ ч олохгүй.
// ⚠ Кодыг ХУВИЛААГҮЙ: `embedded` пропоор нэг эх сурвалжийг дахин
//   ашиглана (хайлт, дуу хоолой, үнэлгээ хоёр газар засагдахгүй).
import KnowledgeAsk from "src/pages/knowledge/ask";
import {
  KNOWLEDGE,
  KNOWLEDGE_GRADIENT,
  KNOWLEDGE_SHADOW,
} from "src/pages/knowledge/theme";
import WorkerHero from "src/components/WorkerHero";
// AI туслахын ТАНИЛЦУУЛГА — туслах өөрөө дэлгэцийн доорх чат (2026-11-04)
import AssistantIntro from "src/components/assistant/AssistantIntro";
// /me → «М-Мэдлэг түүх» таб (Минутын мэдлэгийн хувийн түүх).
//
// СТАТИК импорт — санаатай. Өмнө нь энэ нь `lazy` байсан (knowledge/my →
// knowledge/register гэсэн 49 KB-ын гинжийг /me-ээс салгах зорилготой).
// Харин router.js-д KnowledgeRoute СТАТИК болсон тул тэр код ямар ч
// тохиолдолд main.js дотор орно — lazy байх нь ямар ч хэмжээ хэмнэхгүй,
// зөвхөн /me-г нэмэлт chunk-аас ХАМААРАЛТАЙ болгож эмзэг болгоно.
// Ажилтны хамгийн их хэрэглэдэг хуудас тул хамаарлыг тэглэв.
import { KnowledgeHistoryPanel } from "src/pages/knowledge/my";

// Хурдан оролтын товчнууд (/me дээрх нэг мөрөнд байрлах 2 товч)
const quickBtn = {
  flex: "1 1 260px",
  minWidth: 0,
  display: "flex",
  alignItems: "center",
  gap: 12,
  padding: "12px 16px",
  borderRadius: 10,
  border: "none",
  color: "#fff",
  cursor: "pointer",
  textAlign: "left",
};
const quickBtnDanger = {
  background: "linear-gradient(135deg, #E2382E 0%, #C42B22 100%)",
  boxShadow: "0 3px 12px rgba(226,56,46,0.28)",
};
const quickBtnPrimary = {
  background: KNOWLEDGE_GRADIENT,
  boxShadow: KNOWLEDGE_SHADOW,
};
// «Нээлттэй аюул — өөрөө шийдэх» товч. Шийдвэрлэлт = ногоон (аюул мэдээлэх
// улаан, мэдлэг ягаан-цэнхэр) — гурав нь өнгөөрөө шууд ялгарна.
const quickBtnSuccess = {
  background: "linear-gradient(135deg, #16A34A 0%, #0F7A38 100%)",
  boxShadow: "0 3px 12px rgba(22,163,74,0.28)",
};
const quickBtnIcon = {
  width: 36,
  height: 36,
  borderRadius: 8,
  background: "rgba(255,255,255,0.22)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 16,
  flexShrink: 0,
};
const quickBtnTitle = { display: "block", fontWeight: 800, fontSize: 14 };
const quickBtnSub = { display: "block", fontSize: 11, opacity: 0.9 };

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Аюул мэдээлээд буцаж ирэхэд «Аюулын бүртгэл» таб (6) нээлттэй байна.
  // Хаанаас ирснийг `state.tab`-аар дамжуулдаг (hazard/Register.js).
  const initialTab = Number(location.state?.tab) || 1;
  const [activeTab, setActiveTab] = useState(initialTab);

  // ── Табыг ЭРЭЭЛЖЛЭН ачаалах ────────────────────────────────────────────
  // Өмнө нь 6 панел бүгд зэрэг mount хийгддэг байсан (зөвхөн CSS-ээр
  // нуугддаг) тул хуудас нээхэд 14 useEffect ажиллаж ~17 API дуудлага
  // зэрэг явдаг байв — хэрэглэгч ганцхан таб хардаг ч.
  //
  // Одоо НЭЭГДСЭН таб л mount хийгдэнэ. Нэг удаа нээгдсэн таб санах ойд
  // үлдэнэ (unmount хийхгүй) тул буцаж ирэхэд дахин ачаалахгүй — хуучин
  // зан төлөв хадгалагдана.
  const [openedTabs, setOpenedTabs] = useState(() => new Set([initialTab]));
  const openTab = (key) => {
    setActiveTab(key);
    setOpenedTabs((prev) => (prev.has(key) ? prev : new Set(prev).add(key)));
  };
  // WorkerHero-оос ирэх төлөв: тухайн ажилтан өнөөдөр даалгавартай эсэх.
  // undefined = ачаалж байна, false = энгийн ажилтан, true = даалгавартай.
  const [hasTask, setHasTask] = useState(undefined);

  // Mobile апп-ын WebView дотор нээгдсэн эсэх (localStorage.mobile_app флаг).
  // Тийм бол native-аар шийдсэн хэсгүүдийг — WorkerHero (15 асуумж/аюул
  // мэдээлэх), бие даасан "Аюул мэдээлэх" товч, "Аюулыг мэдээлэх" таб —
  // давхцуулахгүйн тулд нуулгана.
  const isMobileApp = (() => {
    try {
      return (
        typeof window !== "undefined" &&
        window.localStorage.getItem("mobile_app") === "1"
      );
    } catch {
      return false;
    }
  })();

  return (
    <div className="main-content-body main-content-body-profile">
      {/* ӨЭА даалгавар авсан ажилтны hero — 2 баганад хуваасан:
          зүүн талд "Асуумж бөглөх / Аюул мэдээлэх" товч; баруун талд
          өнөөдрийн ажлын дэлгэрэнгүй мэдээлэл. Ажилтан даалгавар аваагүй
          бол энэ хэсэг харагдахгүй (component-аас null буцна). */}
      {!isMobileApp && <AssistantIntro />}
      {!isMobileApp && <WorkerHero onHasTaskChange={setHasTask} />}

      {/* Бие даасан "Аюул мэдээлэх" оролт — ЗӨВХӨН энгийн ажилтанд (даалгавар
          аваагүй) харагдана. Даалгавартай хүнд hero дотор энэ товч аль хэдийн
          байгаа тул давхцуулахгүйн тулд hasTask === false үед л үзүүлнэ. */}
      {/* Хоёр товч НЭГ мөрөнд — нарийн дэлгэц дээр автоматаар доошоо эвхэгдэнэ.
          "Аюул мэдээлэх" нь зөвхөн даалгаваргүй ажилтанд (даалгавартай хүнд
          hero дотор аль хэдийн байгаа), "Минутын мэдлэг" бүх ажилтанд. */}
      {/* Даалгавартай ажилтанд ЭНЭ МӨР ХАРАГДАХГҮЙ — «Аюул мэдээлэх» ба
          «Минутын мэдлэг» хоёул hero-гийн зүүн баганад 3 товч болж орсон.
          Ингэснээр товч 2 газар давхардахгүй. */}
      {!isMobileApp && hasTask !== true && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 10,
            marginBottom: 10,
          }}
        >
          {hasTask === false && (
            <button
              type="button"
              onClick={() => navigate("/hazard/register", {
                // Буцах товч /me-ийн «Аюулын бүртгэл» таб руу
                // (6-р таб) эргэж очихын тулд эх хаягаа дамжуулна.
                state: { from: "/me", tab: 6 },
              })}
              style={{ ...quickBtn, ...quickBtnDanger }}
            >
              <span style={quickBtnIcon}>
                <i className="fas fa-exclamation-triangle" />
              </span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={quickBtnTitle}>Аюул мэдээлэх</span>
                <span style={quickBtnSub}>
                  Илэрсэн аюулыг ХАБ-д шуурхай мэдээлнэ үү
                </span>
              </span>
              <i className="fas fa-chevron-right" style={{ opacity: 0.9 }} />
            </button>
          )}

          <button
            type="button"
            onClick={() => navigate("/knowledge/my")}
            style={{ ...quickBtn, ...quickBtnPrimary }}
          >
            <span style={quickBtnIcon}>
              <i className="fas fa-play-circle" />
            </span>
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={quickBtnTitle}>Минутын мэдлэг</span>
              <span style={quickBtnSub}>
                Өдөрт 1 минутын бичлэг, 1 асуулт · миний оноо
              </span>
            </span>
            <i className="fas fa-chevron-right" style={{ opacity: 0.9 }} />
          </button>
        </div>
      )}

      {/* ── НЭЭЛТТЭЙ АЮУЛ — ӨӨРӨӨ ШИЙДЭХ ───────────────────────────────────
          ⚠ ЭРХИЙН ХЯЗГААРЛАЛТГҮЙ, ӨӨРИЙН МӨРӨНД. Энэ процессын гол санаа нь
          «ажилтан хэн ч байсан» нээлттэй аюулыг хараад шийдэх явдал тул
          оролт нь SSO-гийн цэснээс ХАМААРАХ ЁСГҮЙ (цэс нь эрхээр хумигдана;
          ажилтны ихэнхэд аюулын цэс огт байдаггүй).

          Дээрх мөрөнд НИЙЛҮҮЛЭХГҮЙ: тэр нь `hasTask !== true` үед л
          гардаг — даалгавартай ажилтанд харагдахгүй болно. Энэ товч бол
          ӨДРИЙН ДААЛГАВРААС ҮЛ ХАМААРАХ тул тусдаа. */}
      {!isMobileApp && (
        <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
          <button
            type="button"
            onClick={() => navigate("/hazard/board")}
            style={{ ...quickBtn, ...quickBtnSuccess }}
          >
            <span style={quickBtnIcon}>
              <i className="fas fa-tools" />
            </span>
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={quickBtnTitle}>Нээлттэй аюул — өөрөө шийдэх</span>
              <span style={quickBtnSub}>
                Шийдэгдээгүй бүртгэлээс өөрөө арилгаж чадахыг нь сонгож,
                арга хэмжээгээ бүртгэнэ
              </span>
            </span>
            <i className="fas fa-chevron-right" style={{ opacity: 0.9 }} />
          </button>
        </div>
      )}

      <div className="card">
        <div className="card-header">
          <nav className="nav nav-justified main-nav-line">
            <a
              className={"nav-link" + (activeTab === 1 ? " show active" : "")}
              data-toggle="tab"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                openTab(1);
              }}
            >
              Хамгаалах хэрэгсэл
            </a>
            <a
              className={"nav-link" + (activeTab === 2 ? " show active" : "")}
              data-toggle="tab"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                openTab(2);
              }}
            >
              Сургалт
            </a>
            <a
              className={"nav-link" + (activeTab === 3 ? " show active" : "")}
              data-toggle="tab"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                openTab(3);
              }}
            >
              Хувцасны размер
            </a>
            {/* «ХС бүтээгдэхүүн» — ХСБ Odoo-ийн emc_hse_hsb модуль руу шилжсэн тул
                ажилтны оноолт, олголт, олгох цэгийг порталын «Хор саармагжуулах»
                хуудаснаас харна (хуучин /product/register/worker-ийг орлоно). */}
            <a
              className="nav-link"
              href="https://portal.erdenetmc.mn/salary/hsb"
              target="_blank"
              rel="noreferrer"
            >
              ХС бүтээгдэхүүн
              <i
                className="fas fa-external-link-alt"
                style={{ marginLeft: 6, fontSize: 10 }}
              />
            </a>
            {!isMobileApp && (
              <a
                className={"nav-link" + (activeTab === 5 ? " show active" : "")}
                data-toggle="tab"
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  openTab(5);
                }}
              >
                <i
                  className="fas fa-graduation-cap"
                  style={{ marginRight: 6, color: KNOWLEDGE }}
                />
                М-Мэдлэг түүх
              </a>
            )}
            <a
              className={"nav-link" + (activeTab === 6 ? " show active" : "")}
              data-toggle="tab"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                openTab(6);
              }}
            >
              <i
                className="fas fa-tasks"
                style={{ marginRight: 6, color: "#1B7A45" }}
              />
              Аюулын бүртгэл
            </a>
            <a
              className={"nav-link" + (activeTab === 7 ? " show active" : "")}
              data-toggle="tab"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                openTab(7);
              }}
            >
              <i
                className="fas fa-clipboard-check"
                style={{ marginRight: 6, color: "#C2410C" }}
              />
              Урьдчилсан шалгалт
            </a>
            <a
              className={"nav-link" + (activeTab === 8 ? " show active" : "")}
              data-toggle="tab"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                openTab(8);
              }}
            >
              <i
                className="fas fa-comment-dots"
                style={{ marginRight: 6, color: "#0D7FD6" }}
              />
              Санал гомдол
            </a>
            <a
              className={"nav-link" + (activeTab === 9 ? " show active" : "")}
              data-toggle="tab"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                openTab(9);
              }}
            >
              <i
                className="fas fa-comments"
                style={{ marginRight: 6, color: "#0F6E56" }}
              />
              Журмаас асуух
            </a>
          </nav>
        </div>
        <div className="card-body">
          <div className="tab-content" id="myTabContent">
            <div
              className={
                "tab-pane fade" + (activeTab === 1 ? " show active" : "")
              }
            >
              {openedTabs.has(1) && <Tool />}
            </div>
            <div
              className={
                "tab-pane fade" + (activeTab === 2 ? " show active" : "")
              }
            >
              {openedTabs.has(2) && <Lesson />}
            </div>
            <div
              className={
                "tab-pane fade" + (activeTab === 3 ? " show active" : "")
              }
            >
              {openedTabs.has(3) && <Size />}
            </div>
            {!isMobileApp && (
              <div
                className={
                  "tab-pane fade" + (activeTab === 5 ? " show active" : "")
                }
              >
                {/* `compact` — /me нь аль хэдийн нягт, олон табтай хуудас тул
                    KPI картыг жижиг хувилбараар. `/knowledge/my` бие даасан
                    хуудсанд бүтэн хэмжээгээрээ хэвээр. */}
                {openedTabs.has(5) && <KnowledgeHistoryPanel compact />}
              </div>
            )}
            <div
              className={
                "tab-pane fade" + (activeTab === 6 ? " show active" : "")
              }
            >
              {openedTabs.has(6) && <MyHazards />}
            </div>
            <div
              className={
                "tab-pane fade" + (activeTab === 7 ? " show active" : "")
              }
            >
              {openedTabs.has(7) && <MyPrework />}
            </div>
            {/* ⚠ Мобайл WebView-д Ч ХАРУУЛНА: нативаар нэмэх дэлгэц нь
                нүүрнээс нээгддэг, /me-ээс биш — тул давхцал гарахгүй.
                Харин /me-ээс нуувал WebView-гээр орсон ажилтан санал
                бичих оролтоо олохгүй болно. */}
            <div
              className={
                "tab-pane fade" + (activeTab === 8 ? " show active" : "")
              }
            >
              {openedTabs.has(8) && <MyFeedback />}
            </div>
            <div
              className={
                "tab-pane fade" + (activeTab === 9 ? " show active" : "")
              }
            >
              {/* ⚠ `embedded` — баннерыг нуулгана (таб дотор хоёр баннер
                  болохоос). Таб нь ЗӨВХӨН нэг удаа mount болно
                  (`openedTabs`) тул хайлтын төлөв хадгалагдана. */}
              {openedTabs.has(9) && <KnowledgeAsk embedded />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Index);
